"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureTimeout = exports.configureCommon = void 0;
const timeOut_1 = require("../timeOut");
const features_1 = require("../features");
const features_2 = require("../features");
const plugins_1 = require("../xhr/plugins");
const eventBus_1 = require("../eventBus");
const uiInformation_1 = require("../uiInformation");
const environmentVariables_1 = require("../environmentVariables");
const helpers_1 = require("../xhr/plugins/helpers");
const init_1 = require("../mobileConnector/init");
const authoriser_1 = require("../initializer/authoriser");
(0, eventBus_1.initGlobalEventBus)();
const configureCommon = (session, bankId, language, asyncConnectionMode, UsdManager, { additionalPlugins = [], createAuthoriserPlugin = authoriser => new plugins_1.XHRAuthoriserPlugin(authoriser), } = {}) => {
    const Authoriser = (0, authoriser_1.configureAuthoriser)(asyncConnectionMode);
    features_2.locale.setLocale(language);
    const xhrRequestsBlocker = features_2.XhrRequestsBlockerFactory.getNewXHRRequestsBlocker();
    const invalidateCache = helpers_1.XhrPluginsHelpersFactory.getXhrCheckInvalidateCacheHeader(() => init_1.mobileConnector);
    const plugins = [
        ...additionalPlugins,
        new features_2.XHRAcceptLanguagePlugin(language),
        new features_2.XHRAuthPlugin(session),
        new features_2.XHRBankIdPlugin(bankId),
        new features_2.XHRRefreshSessionPlugin(session, xhrRequestsBlocker),
        createAuthoriserPlugin(Authoriser, (0, features_2.getGlobalEventBus)()),
        new plugins_1.XHRDeviceUuidPlugin(uiInformation_1.getDeviceUUID),
        new plugins_1.XHRInvalidateCachePlugin(invalidateCache),
    ];
    const eventBus = (0, features_2.getGlobalEventBus)();
    const API = new features_2.XHR({ plugins });
    let APICache;
    let GlobalCache;
    if (eventBus) {
        const store = new features_2.Store({ storage: features_2.StorageLocation.Memory });
        GlobalCache = new features_2.CacheV2Synchronized({
            cacheName: 'GlobalCache',
            store,
            eventBus: eventBus,
        });
        APICache = new features_2.XHRAutoCache({
            plugins,
            cache: GlobalCache,
            cacheTTL: 999999999,
            xhr: API,
        });
    }
    const challengeFactory = new features_1.ChallengeFactory(API, session, UsdManager);
    Authoriser.setChallengeFactory(challengeFactory);
    const EnvVariables = new environmentVariables_1.EnviromentVariablesManager();
    return {
        API,
        APICache,
        Authoriser,
        EnvVariables,
        GlobalCache,
    };
};
exports.configureCommon = configureCommon;
const configureTimeout = (session, authenticator) => {
    const TimeOut = new timeOut_1.MbTimeOut(session, authenticator);
    return {
        TimeOut,
    };
};
exports.configureTimeout = configureTimeout;
//# sourceMappingURL=common.js.map